import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-files-menu',
  templateUrl: './files-menu.component.html',
  styleUrls: ['./files-menu.component.css']
})
export class FilesMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
